import {isServer} from '../utils/utils'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

/**
 * Custom hook to get the current host.
 * @returns {string} The current host URL.
 */
const useCurrentHost = () => {
    const {customParams} = getConfig()

    const getHost = () => {
        return !isServer && window.location.origin
            ? window.location.origin
            : `https://${customParams.currentHost}`
    }

    return {
        getHost,
    }
}

export default useCurrentHost
